import { useDropdown } from '@oshcut/components'
import { fetchPost } from '@oshcut/oshlib'
import React, { ReactNode, useMemo, useRef } from 'react'
import { BsBoxArrowRight, BsBoxFill } from 'react-icons/bs'
import { FaBook, FaCartShopping, FaGear } from 'react-icons/fa6'
import { Link, useHistory } from 'react-router-dom'
import { DispatchFunction } from 'reducer'
import { StateType } from 'types'
import './css/UserButton.scss'
import { LinkAnimator } from './LinkAnimator'

type UserButtonProps = {
  state: StateType
  dispatch: DispatchFunction
}

const UserButton = ({ state, dispatch }: UserButtonProps) => {

  const mainButtonRef = useRef<HTMLButtonElement>(null)
  const { Dropdown, openDropdown, closeDropdown } = useDropdown(mainButtonRef)

  const history = useHistory()

  async function handleLogout() {
    fetchPost('/api/v1/customer/logout')
    dispatch({ type: 'ACTION_LOGOUT_USER' })
    sessionStorage.removeItem('orderId')
    sessionStorage.removeItem('submittedOrder')
    history.push('/cart')
    dispatch({ type: 'ACTION_CLEAR_CART' })
    closeDropdown()
  }

  const roleUpperCased = React.useMemo(() => {
    if (!state.customerUser?.role) return ''
    return state.customerUser?.role?.charAt(0).toUpperCase() + state.customerUser?.role.slice(1)
  }, [state.customerUser?.role])

  const avatarContent = useMemo<ReactNode>(() => {
    let initials = '';
    if (state.customerUser?.first_name) {
      initials += state.customerUser.first_name[0]
    }
    if (state.customerUser?.last_name) {
      initials += state.customerUser.last_name[0]
    }
    return initials.toUpperCase();
  }, [state.customerUser])

  return (
    <div className="UserButton">

      <button ref={mainButtonRef} onClick={openDropdown} style={{ position: 'relative' }}>
        <div className={'userAvatar'}>{avatarContent}</div>
        <div>
          <p>{`${state.customerUser?.first_name} ${state.customerUser?.last_name}`}</p>
          {state.customer?.company && <p className='userRole'>{state.customer.company}</p>}

        </div>
        <LinkAnimator message={state.linkAnimatorMessages.account} />
      </button>

      <Dropdown>
        <Link onClick={closeDropdown} to="/account/quotes-orders"><BsBoxFill />Orders</Link>
        <Link onClick={closeDropdown} to="/account/saved-carts"><FaCartShopping />Saved Carts</Link>
        <Link onClick={closeDropdown} to="/account/settings"><FaGear />Settings</Link>
        <div className='logout' onClick={handleLogout}><BsBoxArrowRight />Sign Out</div>
      </Dropdown>

    </div>
  )
}

export default UserButton